import React from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { Box, Typography } from '@mui/material';

const TinyMCEEditor = ({
  value,
  onChange,
  placeholder = 'Start typing...',
  height = 400,
  error,
  helperText,
  disabled = false,
  ...props
}) => {
  const handleEditorChange = (content, editor) => {
    if (onChange) {
      onChange(content);
    }
  };

  return (
    <Box sx={{ width: '100%', minHeight: `${height}px` }}>
      <Editor
        apiKey='n3pcfcky0qj3479siuf4r2fux360te7cnx5clilfwalzk3ko'
        value={value || ''}
        onEditorChange={handleEditorChange}
        disabled={disabled}
        init={{
          height: height,
          menubar: false,
          readonly: disabled,
          // Disable analytics and cloud features to prevent certificate errors
          analytics: false,
          cloud_analytics: false,
          plugins: [
            // Core editing features only (no premium/cloud features)
            'anchor', 'autolink', 'charmap', 'codesample', 'emoticons', 'image', 'link', 'lists', 'media', 'searchreplace', 'table', 'visualblocks', 'wordcount'
          ],
          toolbar_mode: 'wrap',
          toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
          content_style: 'body { font-family: -apple-system, BlinkMacSystemFont, San Francisco, Segoe UI, Roboto, Helvetica Neue, sans-serif; font-size: 14px; }',
          placeholder: placeholder,
          branding: false,
          promotion: false,
          setup: (editor) => {
            editor.on('init', () => {
              // Editor is ready
            });
          },
          // Image upload handling
          images_upload_handler: (blobInfo) => {
            return new Promise((resolve, reject) => {
              // For now, we'll convert to base64
              const reader = new FileReader();
              reader.onload = () => {
                resolve(reader.result);
              };
              reader.onerror = () => {
                reject('Image upload failed');
              };
              reader.readAsDataURL(blobInfo.blob());
            });
          },
          // Paste handling
          paste_data_images: true,
          paste_as_text: false,
          paste_webkit_styles: 'none'
        }}
        {...props}
      />
      {error && helperText && (
        <Typography variant="caption" color="error" sx={{ mt: 1, display: 'block' }}>
          {helperText}
        </Typography>
      )}
    </Box>
  );
};

export default TinyMCEEditor;